import type { RouteObject } from "react-router-dom";

import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

import RulesIndex from "../pages/rules/RulesIndex";
import NLHArticle from "../pages/rules/nlh/NLHArticle";
import PLOArticle from "../pages/rules/plo/PLOArticle";

import AkihabaraPrivatePoker from "../pages/guide/akihabara/AkihabaraPrivatePoker";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },

  {
    path: "/rules",
    element: <RulesIndex />,
  },

  {
    path: "/rules/nlh",
    element: <NLHArticle />,
  },

  {
    path: "/rules/plo",
    element: <PLOArticle />,
  },

  {
    path: "/guide/akihabara-private-poker",
    element: <AkihabaraPrivatePoker />,
  },

  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;